exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".no-link{text-decoration:unset;cursor:unset}", "", {"version":3,"sources":["/var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/navigation/header/header.component.css"],"names":[],"mappings":"AACA,SACE,sBAAuB,YACT,CACf","file":"header.component.css","sourcesContent":["\n.no-link {\n  text-decoration: unset;\n  cursor: unset;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/navigation/header/header.component.css
// module id = ZoyG
// module chunks = 0